import { BaseService } from 'core/services';
import ProductTagRouteService from './ProductTagRouteService';

class ProductTagService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ProductTagRouteService());
    }
}

export default ProductTagService;
